import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ExportFormat } from '@/components/atoms/ExportButton/ExportButton';
import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';

type Props = { onExport: (format: ExportFormat) => void; disabled?: boolean };

export const ExportSubmenu = ({ onExport, disabled }: Props) => {
  const { t } = useTranslation();

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger disabled={disabled} className="gap-2">
        <DownloadIcon size={16} className="text-muted-foreground" />
        {t('common.export')}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuItem onSelect={() => onExport('csv')}>CSV</DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onExport('json')}>JSON</DropdownMenuItem>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
